import { ReactNode } from 'react';
import { Trans } from 'react-i18next';

import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../translations';

type ReceptionServiceSetAsFreeConfirmationEventInterceptorProps = {
   readonly children: ReactNode;
   readonly receptionServiceName: string;
   readonly freeChecked: boolean;
};

export const ReceptionServiceSetAsFreeConfirmationEventInterceptor = (
   props: ReceptionServiceSetAsFreeConfirmationEventInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         shouldShowModal={!props.freeChecked}
         modalWidth={ModalWidth.NORMAL}
         testId={'receptionServiceAsFreeConfirmation'}
         title={receptionServiceTranslationKeys.update.setAsFreeConfirmation.title}
         confirmationButtonLabel={receptionServiceTranslationKeys.update.setAsFreeConfirmation.confirmation}
         content={
            <Trans
               i18nKey={receptionServiceTranslationKeys.update.setAsFreeConfirmation.content}
               components={{ bold: <strong /> }}
               values={{
                  receptionServiceName: props.receptionServiceName,
               }}
            />
         }
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
